import React from 'react'
import injectSheet from 'react-jss'
import styles from './organisation-files-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import OrganisationFilesEntry from './organisation-files-entry/organisation-files-entry.container'

const OrganisationFilesTable = ({ classes, organisationFiles }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.left}>Owner</HeadCell>
        <HeadCell className={classes.left}>Student</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.center}>Conclusion</HeadCell>
        <HeadCell className={classes.center}>Benchmarked</HeadCell>
      </tr>
    </thead>
    <tbody>
      {organisationFiles.map(organisationFile => (
        <OrganisationFilesEntry
          key={organisationFile.id}
          id={organisationFile.id}
        />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(OrganisationFilesTable)
